module.exports = __webpack_public_path__ + "static/media/crecimiento_card.6547938d.png";